import { createApp } from 'vue'
import Contact from './Contact.vue'
import './assets/global.css'

createApp(Contact).mount('#contact')
